import {
  CATEGORY_LINKS_REDUCED_CAP_CIDS,
  CATEGORY_LINKS_CAP_DEFAULT,
  CATEGORY_LINKS_RELATED_CAT_CAP,
  CATEGORY_LINKS_CAP_REDUCED
} from "../../state/modules/category/constants";

const seoFlagEncoded = "&lt;!--friendly--&gt;";
const seoFlagDecoded = "<!--friendly-->";

export const isSeoFriendly = headerHTML =>
  headerHTML.startsWith(seoFlagEncoded) ||
  headerHTML.startsWith(seoFlagDecoded);

export const removeSeoFlagDecoded = str =>
  str.replace(seoFlagEncoded, "").replace(seoFlagDecoded, "").trim();

export const removeHtmlTags = string =>
  string
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/(<([^>]+)>)/g, "")
    .trim();

export const getHeaderTitle = ({
  headerTitle,
  friendlyName,
  headerHtmlEncoded
}) =>
  headerTitle ||
  (isSeoFriendly(headerHtmlEncoded)
    ? removeHtmlTags(removeSeoFlagDecoded(headerHtmlEncoded))
    : friendlyName);

export const getHeaderDisplayText = ({ displayText }) => displayText ?? "";

export function composeCategoryHeaderLinks({
  childLinks = [],
  siblingLinks = [],
  relatedLinks = [],
  breadcrumb,
  categoryId
}) {
  const addCTARefToLinks = links =>
    links.map(link => ({
      ...link,
      linkUrl: `${link.linkUrl}#ctaref-cat_header`
    }));

  const updatedChildLinks = addCTARefToLinks(childLinks);
  const updatedSiblingLinks = addCTARefToLinks(siblingLinks);
  const updatedRelatedLinks = addCTARefToLinks(relatedLinks);

  const isCapped = isCategoryCapped(breadcrumb, categoryId);
  const pillCap = isCapped
    ? CATEGORY_LINKS_CAP_REDUCED
    : CATEGORY_LINKS_CAP_DEFAULT;

  const combinedLinks = [...updatedChildLinks, ...updatedSiblingLinks];

  const relatedLinksToInclude = updatedRelatedLinks.slice(
    0,
    CATEGORY_LINKS_RELATED_CAT_CAP
  );

  const spaceForCombined = pillCap - relatedLinksToInclude.length;
  const trimmedCombinedLinks = combinedLinks.slice(0, spaceForCombined);

  return [...trimmedCombinedLinks, ...relatedLinksToInclude];
}

export const isCategoryCapped = breadcrumb => {
  if (!Array.isArray(breadcrumb) || breadcrumb.length === 0) return false;

  const breadcrumbIds = breadcrumb
    .map(item => Number(item?.CategoryId))
    .filter(id => !isNaN(id) && id !== -1);

  return breadcrumbIds.some(id => CATEGORY_LINKS_REDUCED_CAP_CIDS.includes(id));
};
